import { z } from 'zod';

export const SuperAdminDataPageFilterFormSchema = z.object({
    startDate: z.date().nullable(),
    endDate: z.date().nullable(),
    tenantId: z.string().nullable(),
    hotelId: z.string().nullable(),
    ownerId: z.string().nullable(),
    apartmentId: z.string().nullable(),
    documentNumber: z.string().nullable().optional(),
});

export type SuperAdminDataPageFilterFormData = z.infer<typeof SuperAdminDataPageFilterFormSchema>;
